import { useState } from "react";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";
import { formatLatePaymentPenaltyResponse } from "../../../utils/late-payment-penalty-utils";

export function useLatePaymentPenaltyById() {
    const [latePaymentPenalty, setLatePaymentPenalty] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchLatePaymentPenaltyById(latePaymentPenaltyId) {
        if (!latePaymentPenaltyId) {
            setLatePaymentPenalty(null);
            setError("Não foi possível identificar a penalidade por inadimplência.");

            return {
                ok: false,
                reason: "validation",
                error: "Não foi possível identificar a penalidade por inadimplência."
            };
        }

        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-inadimplencia/${encodeURIComponent(latePaymentPenaltyId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível carregar os dados da penalidade por inadimplência."
                );
            }

            const data = await response.json();

            const latePaymentPenaltyData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedLatePaymentPenalty = formatLatePaymentPenaltyResponse(latePaymentPenaltyData);

            setLatePaymentPenalty(formattedLatePaymentPenalty);

            return {
                ok: true,
                latePaymentPenalty: formattedLatePaymentPenalty
            };
        } catch (requestError) {
            setLatePaymentPenalty(null);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        latePaymentPenalty,
        loading,
        error,
        fetchLatePaymentPenaltyById
    };
}